import type { ButtonHTMLAttributes, Ref } from 'react';

type Variant = 'primary' | 'ghost';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  ref?: Ref<HTMLButtonElement>;
}

const base =
  'inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium ' +
  'transition-colors disabled:cursor-not-allowed disabled:opacity-50';

const variants: Record<Variant, string> = {
  primary:
    'bg-[var(--co-brand)] text-white hover:bg-[#1e293b] focus:outline-none ' +
    'focus:ring-2 focus:ring-[var(--co-brand)] focus:ring-offset-2',
  ghost:
    'bg-transparent text-[var(--co-text)] hover:bg-[var(--co-bg)] ' +
    'border border-[var(--co-border)]',
};

export function Button({ variant = 'primary', className = '', ...rest }: Props) {
  return <button className={`${base} ${variants[variant]} ${className}`} {...rest} />;
}
